<template>
    <div class="areaData">
        <van-popup
            v-model="show"
            position="bottom"
        >
            <van-area
                :area-list="showValue ? areaList : getAreaList"
                :confirm-button-text='confirmText'
                :cancel-button-text='cancelText'
                :title="title"
                :columns-num="showValue ? 2 : 3"
                :value="citiyValue" @cancel='onCancel'
                @confirm='onConfirm'
            />
        </van-popup>
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
    name: 'areaData',
    props: {
        citiyValue: {
            type: String,
            default: () => {}
        },
        showValue: {
            type: Boolean,
            default: false
        },
        areaData: {
            type: Object,
            default: () => {}
        },
        title: {
            type: String,
            default: '选择省市区'
        },
        confirmText: {
            type: String,
            default: '确认'
        }
    },
    data () {
        return {
            show: false,
            areaList: {},
            cancelText: '取消'
        }
    },
    computed: {
        ...mapGetters(['getAreaList'])
    },
    methods: {
        ...mapActions(['getArea']),
        onCancel () {
            this.show = false
        },
        onShow () {
            this.show = true
        },
        onConfirm (obj) {
            if (this.showValue) {
                this.onCancel()
                return false
            }
            let areaData = {
                addressName: obj[0]['name'] + ' ' + obj[1]['name'] + ' ' + obj[2]['name'],
                provinceName: obj[0]['name'],
                provinceId: obj[0]['code'],
                cityName: obj[1]['name'],
                cityId: obj[1]['code'],
                countryName: obj[2]['name'],
                countryId: obj[2]['code']
            }
            this.onCancel()
            this.$emit('onArea', areaData)
        }
    },
    created () {
        let areaData = localStorage.getItem('areaList') ? JSON.parse(localStorage.getItem('areaList')) : ''
        if (!this.showValue) {
            !areaData && this.getArea()
        } else {
            this.cancelText = ' '
            this.areaList = this.areaData
        }
    }
}
</script>
<style lang="scss" scoped>
    /deep/ .van-picker__toolbar{
        height: 108px;
        line-height: 108px;
        font-size: 32px;
    }
    /deep/ .van-picker__cancel{
        font-size: 32px;
        color: #ff7a45;
    }
    /deep/ .van-picker__confirm{
        font-size: 32px;
        color: #ff7a45;
    }
    /deep/ .van-picker__title{
        font-size: 32px;
        line-height: normal;
    }
    /deep/ .van-picker-column{
        font-size: 28px;
        font-weight: 400;
    }
</style>